if (!customElements.get('op-radio-selector-size')) {
    class OpRadioSelectorSize extends HTMLElement {

        connectedCallback() {
            this.section = this.closest(this.dataset.sectionId);
            this.variantUrl = this.dataset.variantUrl;
            this.btn = this.section.querySelector('.js-variant-btn');
            this.btn.href = this.variantUrl;
            this.radio = this.querySelector('input[type="radio"]');
            this.preselected = this.dataset.preselected === 'true';
            this.productId = this.dataset.productId;
            this.radio.addEventListener('change', this.changeHandler);
            this.btn.addEventListener('click', this.confirmChangeSize);
            this.checkPreselected();
        }

        checkPreselected() {
            let storageGetValue = sessionStorage.getItem('confirmChangeSize');
            if (storageGetValue) {
                let obj = JSON.parse(storageGetValue);
                Object.entries(obj).forEach(([prodId, variantId]) => {
                    if(this.productId == prodId && this.radio.value == variantId) {
                        this.preselected = true;
                    }
                });
            }
        }

        confirmChangeSize = () => {
            if (this.radio.checked) {
                this.storageValue[this.productId] = this.radio.value;
                sessionStorage.setItem('confirmChangeSize', JSON.stringify(this.storageValue))
            };
        }

        changeHandler = () => {
            if (this.radio.checked) {
                this.btn.href = this.variantUrl;
            };

        }
    }

    customElements.define("op-radio-selector-size", OpRadioSelectorSize);
}